export interface Rect extends ClientRect {
  x?: number
  y?: number
}

export const DEFAULT_RECT: Rect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
}

const isDOMRect = (rect: ClientRect | DOMRect): rect is DOMRect =>
  (<DOMRect>rect).x !== undefined

export const getCrossbrowserBoundingRect: (
  rect: ClientRect | DOMRect
) => Rect = rect =>
  isDOMRect(rect)
    ? rect
    : {
        x: rect.left,
        y: rect.top,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
      }

export const getBoundingRect: (node: HTMLElement) => Rect = node => {
  const rect =
    node && node.getBoundingClientRect
      ? node.getBoundingClientRect()
      : DEFAULT_RECT

  return getCrossbrowserBoundingRect(rect)
}
